<template>
    <div class="pos-multi-select" :class="{'is-open': open && !disabled, 'is-disabled': disabled}">
        <div class="pos-multi-select__title" @click="handleTitleClick">
            <span v-if="value.length === 0 || disabled">
                <slot></slot>
            </span>
            <template v-else>
                <span>
                    {{ title(getOptionByValue(value[0])) }}
                </span>
                <div class="pos-multi-select__count" v-if="value.length > 1">
                    +{{ value.length - 1 }}
                </div>
            </template>
        </div>
        <div class="pos-multi-select__list" v-if="open && !disabled">
            <div
                class="pos-multi-select__group"
                v-for="(option, i) in options"
                :key="option.id"
            >
                <span v-if="options.length > 1">{{ option.name }}</span>
                <div
                    class="pos-multi-select__option"
                    v-for="(product_group, u) in option.product_groups""
                    :key="product_group.id"
                >
                    <input
                        type="checkbox"
                        :id="uuid(i + '-' + u + '-' + product_group.id)"
                        :value="product_group.id"
                        :checked="isActive(product_group.id)"
                        @change="handleCheck(product_group.id)"
                    >
                    <label :for="uuid(i + '-' + u + '-' + product_group.id)">
                        {{ title(product_group) }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import uuid from "../mixins/uuid";
import selectable from "../mixins/selectable";

export default {
    name: "MultiSelect",
    mixins: [
        uuid,
        selectable
    ],
    props: {
        disabled: Boolean,
        forceClose: Boolean,
        options: {
            type: Array,
            default: () => []
        },
        title: {
            type: Function,
            default: (s) => s
        }
    },
    watch: {
        options: 'cleanModelValue',
        disabled: 'reset',
        forceClose() {
            if (this.forceClose) {
                this.open = false;
            }
        }
    },
    data() {
        return {
            open: false
        }
    },
    methods: {
        getOptionByValue(id) {
            for (let i = 0; i < this.options.length; i++) {
                const found = this.options[i].product_groups.find(o => o.id === id);
                if (found) {
                    return found;
                }
            }
            return null;
        },
        cleanModelValue() {
            this.$emit('input', this.value.filter(v => this.getOptionByValue(v) !== null));
        },
        handleTitleClick() {
            if (!this.disabled) {
                this.open = !this.open;
            }
        },
        reset() {
            this.$emit('input', []);
        }
    }
}
</script>
